import { AdPlacement } from "@/components/ads/AdPlacement";
import { m } from "@/paraglide/messages";
import { UcBreadcrumb } from "../components/UcBreadcrumb";
import { UcCategories } from "../components/UcCategories";
import { UcExplainer } from "../components/UcExplainer";
import { UnitConverter } from "../components/UnitConverter";
import { getCategoryContent } from "../lib/category-content";
import type { UnitCategory } from "../lib/units";

export function CategoryPage({ category }: { category: UnitCategory }) {
  const name = category.name();
  const content = getCategoryContent(category.id);
  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-0 gradient-mesh" />
      <div className="relative mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
        <UcBreadcrumb current={name} />

        <header className="mb-8 mt-6">
          <h1 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">
            {m.uc_cat_h1({ category: name })}
          </h1>
          <p className="mt-3 leading-relaxed text-muted-foreground">
            {m.uc_cat_intro({ category: name })}
          </p>
        </header>

        <UnitConverter category={category} />

        <UcCategories currentId={category.id} />

        {content && (
          <UcExplainer
            howTo={content.howTo()}
            faqs={content.faqs.map((faq) => ({ q: faq.q(), a: faq.a() }))}
          />
        )}

        <AdPlacement className="mt-10" />
      </div>
    </div>
  );
}
